import { styled, spacing, mq, Text } from '@thg-commerce/gravity-theme'

export const Container = styled.div``

export const Heading = styled.div`
  display: none;

  ${Text('bodyText', 'alternate')};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: block;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const NamePlaceholder = styled.span`
  flex: 1;
`

export const Price = styled.span<{ hide?: boolean }>`
  width: 100px;
  display: none;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: ${(props) => (props.hide ? 'none' : 'block')};
    margin: auto ${spacing(3)} auto 0;
  }
`

export const Quantity = styled.span`
  width: 130px;
  margin: auto ${spacing(2)} auto 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    width: 144px;
    margin: auto ${spacing(6)} auto 0;
  }
`

export const Subtotal = styled.span`
  width: 70px;
  margin: auto ${spacing(2)} auto 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    width: 100px;
    margin: auto ${spacing(2)} auto 0;
  }
`

export const ClosePlaceholder = styled.span`
  width: 48px;
`

export const StyledLi = styled.li`
  margin-top: ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: 0px;
  }
`

export const Separator = styled.hr<{ topMargin: number; bottomMargin: number }>`
  border: 0;
  border-top: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  margin-top: ${(props) => `${spacing(props.topMargin)}`};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: ${(props) =>
      `${spacing(props.topMargin)} 0 ${spacing(props.bottomMargin)} 0`};
  }
`
